
export const PAYS_EUROPE_EST = [
  { code: 'BY', nom: 'Biélorussie', capitale: 'Minsk', drapeau: '🇧🇾' },
  { code: 'BG', nom: 'Bulgarie', capitale: 'Sofia', drapeau: '🇧🇬' },
  { code: 'HU', nom: 'Hongrie', capitale: 'Budapest', drapeau: '🇭🇺' },
  { code: 'MD', nom: 'Moldavie', capitale: 'Chisinau', drapeau: '🇲🇩' },
  { code: 'PL', nom: 'Pologne', capitale: 'Varsovie', drapeau: '🇵🇱' },
  { code: 'CZ', nom: 'République Tchèque', capitale: 'Prague', drapeau: '🇨🇿' },
  { code: 'RO', nom: 'Roumanie', capitale: 'Bucarest', drapeau: '🇷🇴' },
  { code: 'RU', nom: 'Russie', capitale: 'Moscou', drapeau: '🇷🇺' },
  { code: 'SK', nom: 'Slovaquie', capitale: 'Bratislava', drapeau: '🇸🇰' },
  { code: 'UA', nom: 'Ukraine', capitale: 'Kiev', drapeau: '🇺🇦' }
];
